/**
 * Created by buddy on 2020-07-20.
 */

export default (state, action) => null;

export const TransactionDetails = (state, action) => {};
